import { render, staticRenderFns } from "./links.vue?vue&type=template&id=228e66e0&scoped=true"
import script from "./links.vue?vue&type=script&lang=ts"
export * from "./links.vue?vue&type=script&lang=ts"
import style0 from "./links.vue?vue&type=style&index=0&id=228e66e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e66e0",
  null
  
)

export default component.exports